import { Store, ClientFactories } from 'bernie-plugin-mobx';
import { ClientLogger } from 'bernie-client';
import { SearchCriteriaStore, AdvertisingStore } from 'stores';
import { CarDetailStore } from './car-detail-store';
import { MultiItemStore } from './multi-item-store';
import { DetailCriteriaStore } from './detail-criteria-store';
import { NewCarSearchListStore } from './car-search-list-v2-store';
import { DropOffCriteriaStore } from './drop-off-criteria-store';
import { CarDropOffStore } from './car-drop-off-store';
import { MapStore } from './map-store';

// export { SearchCriteriaStore, CarDetailStore, CarSearchListStore };
export {
  SearchCriteriaStore,
  CarDetailStore,
  NewCarSearchListStore,
  DropOffCriteriaStore,
  CarDropOffStore,
  MapStore,
  MultiItemStore
};

export const stores: ClientFactories = {
  searchCriteriaStore : (): Store =>
    new SearchCriteriaStore({}, ClientLogger.getLoggerWithIdentifier('car.searchcriteria')),

  detailCriteriaStore : (): Store =>
    new DetailCriteriaStore({}, ClientLogger.getLoggerWithIdentifier('car.detailcriteria')),

  carDetailStore : ({ bexApiContext }): Store =>
    new CarDetailStore({}, ClientLogger.getLoggerWithIdentifier('car.source.detail'), null, bexApiContext),

  mapStore : (): Store => new MapStore({}, ClientLogger.getLoggerWithIdentifier('car.source.map')),

  dropOffCriteriaStore : (): Store =>
    new DropOffCriteriaStore({}, ClientLogger.getLoggerWithIdentifier('car.dropoffcriteria')),

  carDropOffStore : ({ bexApiContext }): Store =>
    new CarDropOffStore({}, ClientLogger.getLoggerWithIdentifier('car.source.dropoff'), null, bexApiContext),

  carSearchListStore : ({ bexApiContext }): Store =>
    new NewCarSearchListStore({}, ClientLogger.getLoggerWithIdentifier('car.source.search'), null, bexApiContext),
  // new CarSearchListStore({}, ClientLogger.getLoggerWithIdentifier('car.source.search'), null, bexApiContext)

  multiItemStore : (): Store => new MultiItemStore({}, ClientLogger.getLoggerWithIdentifier('car.multiItem')),

  advertising : (): Store => new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('car.source.ads'))
};
